/**
 * @generated SignedSource<<1accbc5358e6b7574102b60d8f9f7b21>>
 * @relayHash db19ac8f36a6ada723d67d1d39bcaa01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 52de211b4912d6ed006da5ed2ef0c401bf0c0da340caf7f665e8b57b7e899327

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessTimelineQuery } from './src_jiraBusinessTimelineQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessTimelineQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "52de211b4912d6ed006da5ed2ef0c401bf0c0da340caf7f665e8b57b7e899327",
    "metadata": {},
    "name": "src_jiraBusinessTimelineQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
